import L from 'lodash'

export default {
  namespaced: true,

  state: {
    activities: []
  },

  getters: {
    userActivities (state) {
      return (route) => state.activities.find(o => o.route === route)?.state
    }
  },

  mutations: {
    initializeStore: function (state, storeName) {
      // When app is created the userActivity is get from localStorage
      this.subscribe((mutation, state) => {
        switch (mutation.type) {
          case 'userActivityStore/setUserActivities':
            localStorage.setItem(storeName, JSON.stringify(state['userActivityStore']))
            break
        }
      })
      let itemInLs = localStorage.getItem(storeName)

      // #16726 salvataggio in LS per utente: gestiamo retrocompatibilità con 1.3.0
      if (!itemInLs) {
        const PREV_STORE_NAME = 'Agilis-userActivityStore'
        itemInLs = localStorage.getItem(PREV_STORE_NAME)
        if (itemInLs) {
          localStorage.removeItem(PREV_STORE_NAME)
          localStorage.setItem(storeName, itemInLs)
        }
      }
      // ///////////////////////////////////////////////////////////////////////////

      if (itemInLs) {
        L.merge(state, JSON.parse(localStorage.getItem(storeName)))
      }
    },
    setUserActivities: function (state, { route, delta }) {
      // if userAcitivies already exist for a route, the existing one is overwritten, otherwise it is added
      // state is the state defined in the store
      // activities are defined like this
      /* activities :
        [
          {
            route: "/api/sales/workspace/sorintlab.opportunity/tracker/opportunity",
            state:
            {
              filter: null,
              itemsPerPage: 10,
              sortBy: [],
              sortDesc: [],
              view: "table",
              search: "prova"
            }
          }
        ]
      */
      // where activities.state is defined with the method dumpUserAction({ search: search })
      const index = state.activities.findIndex(o => o.route === route)
      if (index >= 0) {
        const current = state.activities[index].state
        state.activities[index].state = Object.assign({}, current, delta)
      } else {
        state.activities.push({
          route,
          state: delta
        })
      }
    }
  },

  actions: {
    persistUserAction ({ commit, dispatch }, { route, delta }) {
      route && commit('setUserActivities', { route, delta })
    },

    initializeStore ({ commit, rootGetters }) {
      const userId = rootGetters['userDataStore/userId']
      commit('initializeStore', `Agilis-userActivityStore-${userId}`)
    }
  }
}
